import { internalFetch } from '../utils/fetchHelper';

export interface IAction {
  id: number;
  name: string;
}

export interface IPermission {
  id: number;
  name: string;
  actionId: number;
  userId?: number;
  groupId?: number;
}

export interface IUpdatePermission {
  userId?: number;
  groupId?: number;
  actions: number[];
}

export interface IUpdatePermissionsRequest {
  permissions: IUpdatePermission[];
}

export interface IUpdatePermissionsResponse {
  message: string;
}

export const getPermissions = async (
  abortController: AbortController,
  userId?: number,
  groupId?: number,
  actionId?: number
): Promise<IPermission[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/permissions?${
      userId
        ? `userId=${userId}`
        : groupId
        ? `groupId=${groupId}`
        : actionId
        ? `actionId=${actionId}`
        : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getActions = async (
  abortController: AbortController
): Promise<IAction[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/actions?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const updatePermissions = async (
  abortController: AbortController,
  permissions: IUpdatePermissionsRequest
): Promise<IUpdatePermissionsResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/permissions?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(permissions)
  );
};
